import { useContext } from 'react';
import { AlertContext, AlertDispatcher } from '../provider/AlertProvider';

export function useAlert(): AlertDispatcher {
  const showAlert = useContext(AlertContext);
  /* istanbul ignore if */
  if (!showAlert) {
    throw new Error(
      'showAlert value is undefined. Make sure you use the AlertProvider before using the context.'
    );
  }
  return showAlert;
}
